import React from 'react'
import { Redirect } from 'react-router-dom'
import { SEO } from '../../../../components/Seo/seo'
import { FormattedMessage, useIntl } from 'react-intl'
import Layout from '../../../../components/Dashboard/Layout/Layout'
import { NamedRoutes } from '../../../../routes'
import { addService } from '../../../../utils/pages-meta.json'
import { AuthenticatedUserConsumer } from '../../../../AuthenticatedUserContext'
import { ServiceProvider } from '../../../../ServiceContext'
import { FormLoader } from '../../../../components/Loader/FormLoader'
import ServiceEditContent from '../../../../components/Dashboard/Subscription/ServiceEditContent'


const SingleServiceAdd = () => {
  const intl = useIntl()
  return (
    <>
      <SEO title={intl.formatMessage({ id: 'Services.List.AddService.Title' })}
           pathname={window.location.origin}
           titleTemplate={intl.formatMessage({ id: 'E-Tax' })}
           image={addService.image}
           description={intl.formatMessage({ id: 'Services.List.AddService.Title' })}
      />
      <AuthenticatedUserConsumer>
        {({ userDataLoading, userData, handleNotificationCall }) => (
          <>
            {!!userDataLoading && <FormLoader loading={true}/>}
            {!!Object.keys(userData).length &&
            <>
              {!!userData.is_admin ? <Layout content={
                <ServiceProvider pageAction={'add'} handleNotificationCall={handleNotificationCall}>
                  <ServiceEditContent pageTitle={<FormattedMessage id='Services.List.AddService.Title'/>}/>
                </ServiceProvider>
              }/> : (!userDataLoading && <Redirect to={NamedRoutes.home}/>)
              }
            </>
            }
          </>
        )}
      </AuthenticatedUserConsumer>
    </>
  )
}

export default SingleServiceAdd

